import { get, post } from './client';
import type { CreateTransactionRequest, Transaction, TransactionDetail } from '@/types';

/**
 * Create a new payment transaction via BFF Admin API.
 *
 * Returns a Transaction with RedirectUrl where the user should be
 * directed to complete the payment flow. The BFF forwards to the
 * Facade Merchant API when facade integration is enabled.
 */
export async function createTransaction(request: CreateTransactionRequest): Promise<Transaction> {
  return post<Transaction>('/admin/transactions', request);
}

/**
 * Fetch transaction details by ID via BFF Admin API.
 */
export async function getTransaction(transactionId: string): Promise<TransactionDetail> {
  return get<TransactionDetail>(`/admin/transactions/${encodeURIComponent(transactionId)}`);
}
